<template>
  <div class="page-container">
    <div id="searchArea">
      <el-form class="el-form-filter" :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
        <div class="clearfix">
          <div class="fl pb10">
            <el-button type="primary" @click="toNew">Add Package</el-button>
            <el-button @click="toConfig">Business Specification</el-button>
          </div>
          <div class="fr">
            <el-form-item>
              <el-select v-model="dataForm.country" filterable clearable placeholder="Country">
                <el-option v-for="item in countryList" :key="item.value" :label="item.title" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="dataForm.supplierId" clearable placeholder="Supplier" class="fluid-width">
                <el-option v-for="item in supplierList" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="dataForm.businessType" clearable placeholder="Business Type">
                <el-option v-for="item in businessTypes" :key="item.value" :label="item.title" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input v-model="dataForm.keyword" clearable placeholder="Package Name"></el-input>
            </el-form-item>
            <el-button icon="el-icon-search" type="primary" plain v-debounce @click="getDataList(1)">Search</el-button>
          </div>
        </div>
      </el-form>
    </div>
    <div>
      <el-table max-height="680" :data="dataList" v-loading="dataListLoading" style="width: 100%">
        <el-table-column label="Code" prop="packageCode" align="center" width="160"></el-table-column>
        <el-table-column label="Package Name" align="center" min-width="300">
          <template slot-scope="scope">
            <div class="lh16 fs13">{{ scope.row.packageName }}</div>
            <div class="lh16 fs12 grey">{{ scope.row.packageNameCn }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Business Type" prop="businessType" align="center" min-width="250">
          <template slot-scope="scope">
            {{ businessTypeFormat(scope.row.businessType) }}
          </template>
        </el-table-column>
        <el-table-column label="Price" prop="price" align="center" min-width="120">
          <template slot-scope="scope">
            {{ currencyAndAmountFormat(scope.row.currency, scope.row.price) }}
          </template>
        </el-table-column>
        <el-table-column label="Country" prop="country" align="center" min-width="140"></el-table-column>
        <el-table-column label="Supplier" prop="supplier.abbr" align="center" min-width="150"></el-table-column>
        <el-table-column label="Items" align="center" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.serviceList?.length">
              {{ scope.row.serviceList.length }}
              item(s)
            </span>
          </template>
        </el-table-column>
        <el-table-column label="List Total" align="center" width="130">
          <template slot-scope="scope">
            <template v-if="scope.row.serviceList?.length">
              <span :class="{ red: listTotalCalculation(scope.row.serviceList)?.isMismatch }">
                {{ listTotalCalculation(scope.row.serviceList)?.text }}
              </span>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="Sort No." prop="orderNum" align="center" width="80"></el-table-column>
        <el-table-column label="Status" prop="status" align="center" width="90" :formatter="enableAndDisableFormat"></el-table-column>
        <el-table-column label="Update Time" prop="updateTime" align="center" width="164"></el-table-column>
        <el-table-column label="Action" align="center" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" class="fwb" @click="toEdit(scope.row.id)">Edit</el-button>
            <el-button type="text" class="fwb" @click="deleteHandle(scope.row)">Delete</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        :current="current"
        :pageSize="pageSize"
        :totalCount="totalCount"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></pagination>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import priceCountMixin from "@/mixins/priceCountMixin";
import formatterMixin from "@/mixins/formatterMixin";
import paginationMixin from "@/mixins/paginationMixin.js";
import { mapState } from "vuex";
export default {
  mixins: [paginationMixin, priceCountMixin, formatterMixin],
  components: {
    Pagination,
  },
  data() {
    return {
      dataList: [],
      dataListLoading: false,
      dataListSelections: [],
      dataForm: {
        country: "",
        supplierId: "",
        businessType: "",
        keyword: "",
      },
      supplierList: [],
    };
  },
  computed: {
    ...mapState("constant", ["businessTypes", "countryList"]),
  },
  methods: {
    // 获取供应商列表
    getSupplierList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/supplier")
          .then(res => {
            if (res.code === 200) {
              this.supplierList = res.data || [];
              resolve();
            } else {
              this.$message.error(res.msg);
              reject();
            }
          })
          .catch(err => {
            console.error(err);
            reject();
          });
      });
    },
    // 获取分页数据
    async getDataList(current) {
      this.dataListLoading = true;
      if (current) {
        this.current = current;
      }
      const params = {
        current: this.current,
        size: this.pageSize,
        ...this.dataForm,
        "orders[0].asc": false,
        "orders[0].column": "id",
      };
      const { code, data } = await this.$http.get("/admin/package/page", {
        params,
      });
      if (code === 200) {
        this.dataList = data.records;
        this.totalCount = data.total;
      } else {
        this.dataList = [];
        this.totalCount = 0;
      }
      this.dataListLoading = false;
    },
    // 删除
    deleteHandle(row) {
      this.$confirm(`Delete this Plan. Continue?`, "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(async () => {
        const { code, msg } = await this.$http.delete(`/admin/package`, {
          params: {
            "ids[]": row.id,
          },
        });
        if (code === 200) {
          this.$message({
            message: "success",
            type: "success",
            duration: 1500,
            onClose: () => {
              // mixins
              this.singleDataDelete();
              this.getDataList();
            },
          });
        } else {
          this.$message.error(msg);
        }
      });
    },
    // 新建
    toNew() {
      this.$router.push("/sys/pkg/plan/add");
    },
    // 编辑
    toEdit(id) {
      this.$router.push(`/sys/pkg/plan/${id}/edit`);
    },
    // 前台服务说明banner配置
    toConfig() {
      this.$router.push("/sys/pkg/plan/config");
    },
  },
  activated() {
    this.getSupplierList();
    this.getDataList();
  },
};
</script>
